module.exports = __webpack_public_path__ + "static/media/articles-2.5f37de86.png";